export const SEND_SIGN_UP_REQUEST = "SEND_SIGN_UP_REQUEST"
export const SEND_SIGN_UP_REQUEST_FAIL = "SEND_SIGN_UP_REQUEST_FAIL"
export const SEND_SIGN_UP_REQUEST_SUCCESS = "SEND_SIGN_UP_REQUEST_SUCCESS"
export const SEND_SIGN_UP_REQUEST_RESET = "SEND_SIGN_UP_REQUEST_RESET"

export const sendSignUpRequest = (params) => {
    return { type: SEND_SIGN_UP_REQUEST, params }
}

export const sendSignUpRequestSuccess = (response) => {
    return { type: SEND_SIGN_UP_REQUEST_SUCCESS, response }
}

export const sendSignUpRequestFail = (response) => {
    return { type: SEND_SIGN_UP_REQUEST_FAIL, response }
}

export const sendSignUpRequestReset = (response) => {
    return { type: SEND_SIGN_UP_REQUEST_RESET, response }
}


